import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";
import Button from "@material-ui/core/Button";

import { Input } from "components/tools/Size";
import { useStoreon } from "storeon/react";
import t from "translations";

const Wrap = styled.div`
  margin-top: 15px;
`;

const ControlsWrap = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
`;

const RadiusManager = props => {
  const [radius, setRadius] = useState(25);

  const { dispatch, canvas } = useStoreon("canvas");
  const setCutRadius = (newRadius, canvas) => {
    const { cutZone } = canvas.DPE;
    const { maxWidth, maxHeight, minWidth, minHeight } = canvas.settings;
    let rad = newRadius ? parseFloat(newRadius) : parseFloat(radius);
    const max = maxWidth > maxHeight ? maxWidth : maxHeight;
    const min = minWidth < minHeight ? minWidth : minHeight;
    if (rad < min || rad > max) {
      dispatch("notification/warning", `Diameter should be ${min} - ${max} cm`);
    }
    if (rad < min) {
      rad = min;
    }
    if (rad > max) {
      rad = max;
    }
    setRadius(rad);
    cutZone.setCutRadius(rad * 5);
    cutZone.updateSize(rad * 10, rad * 10);
    cutZone.fitCutZone();
  };

  useEffect(() => {
    if (!canvas) {
      return;
    }

    const cutZone = canvas.DPE.cutZone;
    const rad = 50;
    setRadius(rad);
    cutZone.setCutRadius(rad * 5);
    cutZone.updateSize(rad * 10, rad * 10);
    cutZone.fitCutZone();
  }, [canvas]);

  if (!canvas) {
    return;
  }
  const handleInputChange = e => {
    setRadius(e.target.value);
  };
  const handleRadiusChange = e => {
    if (e.key === "Enter") {
      setCutRadius(undefined, canvas);
    }
  };
  const handleUpdateRadius = e => {
    setCutRadius(undefined, canvas);
  };

  return (
    <Wrap>
      <ControlsWrap>
        <Input
          label={t.diameter}
          value={radius}
          onChange={handleInputChange}
          onKeyPress={handleRadiusChange}
        />
        <Button
          variant="contained"
          color="secondary"
          onClick={handleUpdateRadius}
        >
          {t.update}
        </Button>
      </ControlsWrap>
    </Wrap>
  );
};

export default RadiusManager;
